<template>
  <b-form-group>
    <template v-slot:label>
      <label class="form-group__label form-group__label--required">{{
        $t("dashboard.email_message_data")
      }}</label>
    </template>
    <quill-editor-variables
      v-model="message"
      emitWithChangeSource
      :tags="tags"
      :editorOptions="editorOptions"
    >
      <template #btn-content>
        {{ $t("edit_campaign.email_template_edit_title") }}
      </template>
      <template #description>
        {{ $t("edit_campaign.email_template_var_description") }}
      </template>
      <template #tags-full-text="{ tagsFull }">
        {{
          tagsFull
            ? $t("edit_campaign.email_template_show_description")
            : $t("edit_campaign.email_template_hide_description")
        }}
      </template>
      <template #between-tags-and-editor="{ value }">
        <OrgMessageTemplates
          type="email"
          :templateText="value.value"
          :propTemplateId="templateId"
          @update:templateText="(v) => (message = { value: v })"
          @update:changeTemplate="changeTemplate"
        />
      </template>
    </quill-editor-variables>
  </b-form-group>
</template>

<script>
import quillEditorVariables from "@/common-components/ui-elements/quill-editor-variables.vue";
import { mapState } from "vuex";
import { defineComponent } from "vue";
import OrgMessageTemplates from "@/components/org-message-templates.vue";

export default defineComponent({
  components: {
    quillEditorVariables,
    OrgMessageTemplates,
  },
  props: {
    templateId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      message: "",
      editorOptions: {
        modules: {
          toolbar: {
            container: [
              ["bold", "underline", "strike", "italic"],
              ["blockquote"],
              [{ list: "ordered" }, { list: "bullet" }],
              [{ size: ["small", false, "large", "huge"] }],
              [{ align: [] }],
              [{ color: [] }, { background: [] }],
              ["image"],
              ["link"],
              ["clean"],
            ],
          },
          imageResize: {
            modules: ["Resize", "DisplaySize"],
            displayStyles: {
              backgroundColor: "black",
              border: "none",
              color: "white",
            },
          },
        },
      },
    };
  },
  computed: {
    ...mapState({
      metas: (state) => state.campaign.metas,
    }),
    tags() {
      let options = [
        {
          value: "{{.Team.ID}}",
          text: this.$t("dashboard.email_message_tag_team_id", "Team ID"),
        },
        {
          value: "{{.Team.CampaignID}}",
          text: this.$t("dashboard.email_message_tag_team_campaign_id", "Team Campaign ID"),
        },
        {
          value: "{{.Team.Name}}",
          text: this.$t("dashboard.email_message_tag_team_name", "Team Name"),
        },
        {
          value: "{{.Team.Slug}}",
          text: this.$t("dashboard.email_message_tag_team_slug", "Team Slug"),
        },
        {
          value: "{{.Team.Description}}",
          text: this.$t("dashboard.email_message_tag_team_description", "Team Description"),
        },
        {
          value: "{{.Team.Goal}}",
          text: this.$t("dashboard.email_message_tag_team_goal", "Team Goal"),
        },
        {
          value: "{{.Team.LeaderName}}",
          text: this.$t("dashboard.email_message_tag_team_leader_name", "Team Leader Name"),
        },
        {
          value: "{{.Team.LeaderEmail}}",
          text: this.$t("dashboard.email_message_tag_team_leader_email", "Team Leader Email"),
        },
        {
          value: "{{.Team.ParentTeamID}}",
          text: this.$t("dashboard.email_message_tag_team_parent_team_id", "Team Parent Team ID"),
        },
        {
          value: "{{.Team.ParentTeamID2}}",
          text: this.$t("dashboard.email_message_tag_team_parent_team_id2", "Team Parent Team ID2"),
        },
        {
          value: "{{.Team.Group}}",
          text: this.$t("dashboard.email_message_tag_team_group", "Team Group"),
        },
        {
          value: "{{.Team.Hidden}}",
          text: this.$t("dashboard.email_message_tag_team_hidden", "Team Hidden"),
        },
        {
          value: "{{.Team.Nominated}}",
          text: this.$t("dashboard.email_message_tag_team_nominated", "Team Nominated"),
        },
      ];

      const allowTeamUpdateByPublicToken =
        this.metas["allow_team_update_by_public_token"]?.value || false;
      if (allowTeamUpdateByPublicToken) {
        options = [
          ...options,
          {
            value: "[TOKEN]",
            text: this.$t("dashboard.email_message_tag_token"),
          },
          {
            value: "[TOKEN_GOAL_GROUP_<groupname>]",
            text: this.$t(
              "dashboard.email_message_tag_token_goal_group",
              "Token for specific goal group (replace <groupname> with the actual group name)"
            ),
          },
        ];
      }

      return options;
    },
  },
  methods: {
    changeTemplate(id) {
      this.$emit("templeteId", id);
    },
  },
});
</script>
